module.exports = __webpack_public_path__ + "img/roadside.071b0849.png";